/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_DescInputs */

const en_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All jobs, documents, and next steps in one place. You review and decide what happens next.`)
};

const de_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Stellen, Unterlagen und nächsten Schritte an einem Ort. Du prüfst und entscheidest, was als Nächstes passiert.`)
};

const fr_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes vos offres, vos documents et les prochaines étapes au même endroit. Vous examinez et décidez de la suite.`)
};

const es_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las ofertas, documentos y próximos pasos en un solo lugar. Revisas y decides qué ocurre después.`)
};

const it_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le offerte, i documenti e i prossimi passi in un unico posto. Rivedi e decidi cosa succede dopo.`)
};

const nl_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle vacatures, documenten en volgende stappen op één plek. Je beoordeelt en beslist wat er daarna gebeurt.`)
};

const pl_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie oferty, dokumenty i kolejne kroki w jednym miejscu. Sprawdzasz i decydujesz, co wydarzy się dalej.`)
};

const fi_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki työpaikat, asiakirjat ja seuraavat vaiheet yhdessä paikassa. Tarkistat ja päätät, mitä seuraavaksi tapahtuu.`)
};

const da_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle job, dokumenter og næste skridt samlet ét sted. Du gennemgår og beslutter, hvad der sker bagefter.`)
};

const sv_landing_application_overview_desc = /** @type {(inputs: Landing_Application_Overview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla jobb, dokument och nästa steg på ett ställe. Du granskar och bestämmer vad som händer härnäst.`)
};

/**
* | output |
* | --- |
* | "All jobs, documents, and next steps in one place. You review and decide what happens next." |
*
* @param {Landing_Application_Overview_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_desc = /** @type {((inputs?: Landing_Application_Overview_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_desc(inputs)
	if (locale === "fr") return fr_landing_application_overview_desc(inputs)
	if (locale === "es") return es_landing_application_overview_desc(inputs)
	if (locale === "it") return it_landing_application_overview_desc(inputs)
	if (locale === "nl") return nl_landing_application_overview_desc(inputs)
	if (locale === "pl") return pl_landing_application_overview_desc(inputs)
	if (locale === "fi") return fi_landing_application_overview_desc(inputs)
	if (locale === "da") return da_landing_application_overview_desc(inputs)
	if (locale === "sv") return sv_landing_application_overview_desc(inputs)
	return en_landing_application_overview_desc(inputs)
});